import React from "react";
import { Body1 } from "@material/react-typography";
import NoAuthTopoCard from "~/components/common/NoAuthTopoCard";

export const ValidatingMessage = "Validating login information...";

export const Validating: React.FC = () => {
  return (
    <NoAuthTopoCard>
      <Body1>{ValidatingMessage}</Body1>
    </NoAuthTopoCard>
  );
};
